import { Component, Input, OnInit } from '@angular/core';
import { AdminUserService, User } from '@shared/services/admin-user.service';
import { AdminProfileService, Profile } from '@shared/services/admin-profile.service';
import { ToastrService } from '@shared/services/toastr.service';
import { Location, NgFor, NgIf } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Lang } from '@shared/utils/lang';
import { AdminService } from '@shared/services/admin.service';
import { ADMIN_PREFIX } from '../../../../app-routing.constants';
import { ORGANIZATIONS_ROUTE } from '../../admin-routing.module';
import { SwitchComponent } from '@shared/components/switch/switch.component';
import { RouterLink } from '@angular/router';
import { BadgeOrganizationComponent } from '@shared/components/badge-organization/badge-organization.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrl: './edit-user.component.scss',
  imports: [
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    SwitchComponent,
    NgFor,
    RouterLink,
    BadgeOrganizationComponent,
    TranslatePipe,
  ],
})
export class EditUserComponent implements OnInit {
  user!: EditedUser;
  @Input()
  set id(userId: number) {
    this.adminUserService.getUser(userId).subscribe((user) => {
      this.user = user;
      if (user.hasApiKey) this.user.apiKey = this.apiKeyPlaceHolder;
      this.form.patchValue(this.user);
    });
  }

  form = new FormGroup({
    email: new FormControl<string>(null, [Validators.required, Validators.email]),
    firstName: new FormControl<string | null>(null),
    lastName: new FormControl<string | null>(null),
    lang: new FormControl<Lang>('en'),
    active: new FormControl<boolean>(false),
    profile: new FormControl<string>(null),
    apiKey: new FormControl<string>(null),
  });

  protected profiles: Profile[];

  apiKeyPlaceHolder = '⬤⬤⬤⬤⬤⬤⬤⬤⬤⬤⬤⬤⬤⬤⬤⬤';

  constructor(
    private adminProfileService: AdminProfileService,
    private adminUserService: AdminUserService,
    private location: Location,
    private toastr: ToastrService,
    protected readonly adminService: AdminService,
  ) {
    console.log('EditUserComponent');
  }

  ngOnInit() {
    this.adminProfileService.getProfiles().subscribe((res) => (this.profiles = res));
  }

  updateUser() {
    const req = this.form.getRawValue();
    if (req.apiKey == this.apiKeyPlaceHolder) {
      delete req.apiKey;
    }
    this.adminUserService.updateUser(this.user.id, req).subscribe((_) => {
      this.toastr.success();
      this.location.back();
    });
  }

  cancel() {
    this.location.back();
  }

  resendRegistrationMail(user: { email: string }) {
    this.adminUserService.resendRegistrationMail(user.email).subscribe((res) => {
      if (res.hasError) {
        this.toastr.error();
      } else {
        this.toastr.success();
      }
    });
  }

  protected readonly ADMIN_PREFIX = ADMIN_PREFIX;
  protected readonly ORGANIZATIONS_ROUTE = ORGANIZATIONS_ROUTE;
}

type EditedUser = Omit<User, 'hasApiKey' | 'createdAt' | 'createdBy'> & { apiKey?: string };
